import { AccredibleLinkComponentModule } from '@accredible-frontend-v2/new-components/link';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

type styleType = 'CF' | 'DOD';

@Component({
  selector: 'accredible-read-more',
  standalone: true,
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AccredibleLinkComponentModule],
})
export class AccredibleReadMoreComponent {
  styleType = input<styleType>('CF');
  title = input<string>('');
  subtitle = input<string>('');
  url = input<string>('');
  urlLabel = input<string>('');
  ariaLabel = input<string>('');
  horizontalStyle = input<boolean>(false);
}
